import { isEligibleEnv, sendErrorToSentry } from './sentry-service.js';
import { CURRENT_ENVIRONMENT } from '../utils/environment-utils.js';

const handleError = (error) => {
    if (isEligibleEnv(CURRENT_ENVIRONMENT)) {
        sendErrorToSentry(error);
    }
};

export { handleError };
//# sourceMappingURL=error-boundary-service.js.map
